import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';

import { useOnImportFinished } from '../../../../components/csv-import/data/hooks/use-on-import-finished';
import { ImportStatus } from '../../../../components/csv-import/data/types/import-status';
import { ImportType } from '../../../../components/csv-import/data/types/import-type';
import { useCsvImport } from '../../../../components/csv-import/ui/hooks/use-csv-import';
import Global from '../../../../store/global-selectors';
import { Workflows } from '../../../../tracking/tracking-constants';
import { WorkflowSteps, useTrackWorkflow } from '../../../../tracking/use-workflow-tracking';
import { InventoryImportDrawer } from '../modals/import/inventory-import-drawer/inventory-import-drawer';

/**
 * @param {object} props
 * @param {(arg: () => void) => React.ReactNode} props.renderOpener
 * @param {() => void} [props.onImportFinish]
 * @returns {JSX.Element}
 */
export const InventoryImport = ({ renderOpener, onImportFinish }) => {
  const latestImport = useSelector((state) => Global.selectCsvImportType(state, ImportType.inventory));

  const { open: openModal, close: closeModal, isOpen: isModalOpen } = useCsvImport(ImportType.inventory);

  const location = useLocation();

  const trackImportProcessV2 = useTrackWorkflow(Workflows.CSV_INVENTORY_IMPORT_FLOW);

  const openImportModalV2 = () => {
    if (latestImport.status !== ImportStatus.ACTIVE) {
      trackImportProcessV2(WorkflowSteps.START, {
        version: 2,
        location: location.pathname,
      });
    }
    openModal();
  };

  useOnImportFinished(
    ImportType.inventory,
    useCallback(() => {
      if (isModalOpen && onImportFinish) {
        onImportFinish();
      }
    }, [isModalOpen, onImportFinish]),
  );

  return (
    <>
      {renderOpener(openImportModalV2)}
      {isModalOpen ? <InventoryImportDrawer onClose={closeModal} trackProcess={trackImportProcessV2} /> : null}
    </>
  );
};
